import { render, staticRenderFns } from "./MasonryLayout.vue?vue&type=template&id=38fea0ef&scoped=true"
import script from "./MasonryLayout.vue?vue&type=script&lang=js"
export * from "./MasonryLayout.vue?vue&type=script&lang=js"
import style0 from "./MasonryLayout.vue?vue&type=style&index=0&id=38fea0ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fea0ef",
  null
  
)

export default component.exports